import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { authMutationKeys } from '../constants'

export const useLoginVerifyEmailMutation = (options) => {
  const handleMutation = async ({ token }) => {
    const config = {
      method: 'post',
      data: {
        token
      }
    }

    const { data } = await api('/api/me/email/verify', config)
    return data
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: authMutationKeys.EMAIL_MUTATION,
    retry: 0,
    ...options,
    onSuccess: (data, { postId, fileId }, context) => {
      // Call user callback with all original parameters
      options?.onSuccess?.(data, { postId, fileId }, context)
    },
    onError: (error, { postId, fileId }, context) => {
      // Call user callback with all original parameters
      options?.onError?.(error, { postId, fileId }, context)
    }
  })
}
